import { render, staticRenderFns } from "./AiFieldsLogs.vue?vue&type=template&id=57b2601c&scoped=true"
import script from "./AiFieldsLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./AiFieldsLogs.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b2601c",
  null
  
)

export default component.exports